import { render, staticRenderFns } from "./AdressList.vue?vue&type=template&id=a915ea98&"
import script from "./AdressList.vue?vue&type=script&lang=js&"
export * from "./AdressList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AdressList.vue"
export default component.exports